import React, { Component } from 'react'
import { connect } from 'react-redux'
import { get, post } from '../../services/apiServices'
import { token } from '../../services/authServices'
import Select from "material-ui/Select";
import { MenuItem } from "material-ui/Menu";
import { InputLabel } from "material-ui/Input";
import { FormControl } from "material-ui/Form";
import {
    usersAction,
    classRoomsAction
} from '../../actions/contentActions'
import { StoryMode, ChallengeMode, Effort, ChallengeDetails } from '../content/ReportComponents'
import Tabs from 'material-ui/Tabs';
import { Tab } from 'material-ui/Tabs';
import Grid from "material-ui/Grid";


const styles = {
	classRoomSelect : {
        minWidth: '200px',
        marginLeft: '10px'
    },
    classRoomSelectMenu : {
        minWidth: '200px',
    },
};

export default class ReportContainer extends Component {
    state = {
        activeTab: 0,
        classRooms: [],
        classRoomId: 0
    }

    componentDidMount() {
        if (this.props.isSchool) {
            get(`/admin/accounts/${this.props.accountId}/classes?all=true`, token).then(res => {
                this.setState({ classRooms: res.data.data });
            })
        }
    }
    handleTabChange = (event, activeTab) => {
        this.setState({ activeTab });
    }
    handleClassChange = (event) => {
        this.setState({ classRoomId: event.target.value })
    }
    render() {
        const { activeTab, classRooms, classRoomId } = this.state
        const { accountId, isSchool } = this.props
        return (
            <div>
                <div className="top-panel">
                    <Grid container spacing={8}>
                        <Grid item xs={9}>
                            <Tabs
                                indicatorColor="primary"
                                textColor="primary"
                                value={activeTab}
                                onChange={this.handleTabChange}>
                                <Tab label="Story Mode" />
                                <Tab label="Challenge Mode Summary" />
                                <Tab label="Challenge Mode Learning Objectives" />
                                <Tab label="Effort" />
                            </Tabs>
                        </Grid>
                        {isSchool && <Grid item xs={3}>
                            <InputLabel htmlFor="stage-select">
                                Class
                            </InputLabel>
                            <Select
                                style={styles.classRoomSelect}
                                value={this.state.classRoomId}
                                onChange={this.handleClassChange}
                                autoWidth
                            >
                                <MenuItem value={0} style={styles.classRoomSelectMenu}>
                                    Whole school
                                </MenuItem>
                                {classRooms && classRooms.map((item, index) => {
                                    return (
                                        <MenuItem key={index} value={item.id} style={styles.classRoomSelectMenu}>
                                            {item.name}
                                        </MenuItem>
                                    )
                                })}
                            </Select>
                        </Grid>}
                    </Grid>
                </div>

                {activeTab === 0 && <StoryMode
                    accountId={accountId}
                    classRoomId={classRoomId}
                />}
                {activeTab === 1 && <ChallengeMode
                    accountId={accountId}
                    classRoomId={classRoomId}
                />}
                {activeTab === 2 && <ChallengeDetails
                    accountId={accountId}
                    classRoomId={classRoomId}
                />}
                {activeTab === 3 && <Effort
                    accountId={accountId}
                    classRoomId={classRoomId}
                />}
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/containers/ReportContainer.js